// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.main-container {
  display: block;
  margin: 10px;
  /*    margin: 7px;
    margin-bottom: 21px;*/
}
.main-container.dragged {
  position: absolute;
  opacity: 0;
}

mat-card {
  padding: 3px;
  padding-top: 24px;
  padding-bottom: 3px;
}

.text-container {
  margin-left: 10px;
  margin-right: 10px;
  font-size: 13px;
  padding-top: 6px;
  line-height: 15px;
}

.element-content {
  position: relative;
}

.idea {
  position: relative;
  min-height: 50px;
}
.idea.dragged {
  position: absolute;
}
.idea .buttons {
  position: absolute;
  right: 0;
  top: 5px;
  cursor: pointer;
}
.idea .content-text {
  margin-top: 5px;
  white-space: pre-wrap;
}

.action-button {
  position: absolute;
  right: -8px;
  top: -4px;
  z-index: 2;
}

.username {
  font-size: 11px;
  font-weight: bold;
  text-align: right;
  border-top: 0.25px solid #dbdbdb;
  padding: 5px;
  margin-top: 14px;
  width: 100%;
}

mat-icon {
  font-size: 15px;
  width: 18px;
  min-width: 18px;
}

.placeholder {
  border: 2px dashed lightgray;
  border-radius: 4px;
}
.placeholder.before-placeholder {
  margin-bottom: 10px;
}
.placeholder.after-placeholder {
  margin-top: 10px;
}`, "",{"version":3,"sources":["webpack://./src/app/@modules/ideas-wall/core/idea-item/idea-item.component.scss"],"names":[],"mappings":"AAAA;EAEE,cAAA;EACA,YAAA;EACA;yBAAA;AACF;AAEE;EACE,kBAAA;EACA,UAAA;AAAJ;;AAIA;EACE,YAAA;EACA,iBAAA;EACA,mBAAA;AADF;;AAKA;EACE,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;AAFF;;AAKA;EACE,kBAAA;AAFF;;AAKA;EACE,kBAAA;EACA,gBAAA;AAFF;AAIE;EACE,kBAAA;AAFJ;AAME;EACE,kBAAA;EACA,QAAA;EACA,QAAA;EACA,eAAA;AAJJ;AAOE;EAEE,eAAA;EACA,qBAAA;AANJ;;AAUA;EACE,kBAAA;EACA,WAAA;EACA,SAAA;EACA,UAAA;AAPF;;AAWA;EAEE,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,gCAAA;EACA,YAAA;EACA,gBAAA;EACA,WAAA;AATF;;AAYA;EACE,eAAA;EACA,WAAA;EACA,eAAA;AATF;;AAYA;EACE,4BAAA;EACA,kBAAA;AATF;AAWE;EACE,mBAAA;AATJ;AAYE;EACE,gBAAA;AAVJ","sourcesContent":[".main-container {\n  //position: relative;\n  display: block;\n  margin: 10px;\n  /*    margin: 7px;\n    margin-bottom: 21px;*/\n\n  &.dragged {\n    position: absolute;\n    opacity: 0;\n  }\n}\n\nmat-card {\n  padding: 3px;\n  padding-top: 24px;\n  padding-bottom: 3px;\n  //font-family:'nexa';\n}\n\n.text-container {\n  margin-left: 10px;\n  margin-right: 10px;\n  font-size: 13px;\n  padding-top: 6px;\n  line-height: 15px;\n}\n\n.element-content {\n  position: relative;\n}\n\n.idea {\n  position: relative;\n  min-height: 50px;\n\n  &.dragged {\n    position: absolute;\n    //opacity: 0;\n  }\n\n  .buttons {\n    position: absolute;\n    right: 0;\n    top: 5px;\n    cursor: pointer;\n  }\n\n  .content-text {\n    //margin: 10px;\n    margin-top: 5px;\n    white-space: pre-wrap;\n  }\n}\n\n.action-button {\n  position: absolute;\n  right: -8px;\n  top: -4px;\n  z-index: 2;\n}\n\n\n.username {\n  //font-family: \"nexabold\";\n  font-size: 11px;\n  font-weight: bold;\n  text-align: right;\n  border-top: 0.25px solid #dbdbdb;\n  padding: 5px;\n  margin-top: 14px;\n  width: 100%;\n}\n\nmat-icon {\n  font-size: 15px;\n  width: 18px;\n  min-width: 18px;\n}\n\n.placeholder {\n  border: 2px dashed lightgray;\n  border-radius: 4px;\n\n  &.before-placeholder {\n    margin-bottom: 10px;\n  }\n\n  &.after-placeholder {\n    margin-top: 10px;\n  }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
